import { render, staticRenderFns } from "./studyIndex.vue?vue&type=template&id=1b9e7071&scoped=true"
import script from "./studyIndex.vue?vue&type=script&lang=js"
export * from "./studyIndex.vue?vue&type=script&lang=js"
import style0 from "./studyIndex.vue?vue&type=style&index=0&id=1b9e7071&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9e7071",
  null
  
)

export default component.exports